var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      !_vm.$route.path.includes("checkout/mobile/pedidos") &&
      !_vm.$route.path.includes("checkout/mobile/assinaturas")
        ? _c("navbar")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-wrapper" },
        [
          _c("email-not-verified-dialog"),
          _vm._v(" "),
          _c(
            "keep-alive",
            [
              _c(
                "transition",
                { attrs: { name: "zoom", mode: "out-in" } },
                [_c("router-view")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.$route.path.includes("checkout/mobile/pedidos") &&
      !_vm.$route.path.includes("checkout/mobile/assinaturas")
        ? _c("Footer")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cd43513", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cd43513","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wrapper.vue
// module id = null
// module chunks = 